import { useState } from "react";
import Button from "../../../Buttons/Button";
import ModalEditAdvantageEnhances from "./ModalEditAdvantageEnhances";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";

const EditAdvantageEnhances = ({
  adID,
  adPathForm,
  onCallbackSelect = () => {},
  disabled = false,
}) => {
  const [modalEditAdvantageEnhancesOpen, setModalEditAdvantageEnhancesOpen] =
    useState(false);

  if (disabled) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
        }}
      >
        <Button
          type="button"
          color="secondary"
          sx={{
            width: "fit-content",
            minWidth: "fit-content",
          }}
          onClick={() => setModalEditAdvantageEnhancesOpen(true)}
        >
          <EditIcon />
        </Button>
      </Box>
      {modalEditAdvantageEnhancesOpen && (
        <ModalEditAdvantageEnhances
          modalOpen={modalEditAdvantageEnhancesOpen}
          onCloseModal={() => setModalEditAdvantageEnhancesOpen(false)}
          adID={adID}
          adPathForm={adPathForm}
          onCallbackSelect={onCallbackSelect}
        />
      )}
    </>
  );
};

export default EditAdvantageEnhances;
